import React from 'react'
import injectStyles from 'react-jss'

import { Col } from 'react-bootstrap'
import SubmitButton from '../../../../../Components/Form/SubmitButton'
import { Input } from '../../../../../Components/Form'
import Form from 'Components/Form'
import { required, number } from 'Utils/Validators/formValidation'
import { CITY_PROGRAMS } from '../options'
import styles from './styles'

const ProgramForm = ({
  onUpdate,
  onSubmit,
  classes,
  programType,
  isDisabled,
  maxBudget,
}) => (
  <div className={classes.form}>
    <Form onUpdate={onUpdate} onSubmit={onSubmit}>
      {programType === CITY_PROGRAMS.PROMO ? (
        <Col xs={3}>
          <Input
            label="Promo Code"
            name="promoCode"
            placeholder=""
            validator={[required]}
            cypress_id="edit-city-promo-code-input"
          />
        </Col>
      ) : null}
      <Col xs={3}>
        <Input
          label="Mission Trigger"
          name="missionsTrigger"
          placeholder=""
          validator={[required, number]}
          cypress_id="edit-city-mission-trigger-input"
        />
      </Col>
      <Col xs={3}>
        <Input
          label="Reward per BA"
          name="bonusAmount"
          placeholder=""
          validator={[required, number]}
          cypress_id="edit-city-reward-per-ba-input"
        />
      </Col>
      <Col xs={3}>
        <Input
          label={`Max Signup (max. budget ${maxBudget})`}
          name="signUpLimit"
          placeholder=""
          validator={[required, number]}
          cypress_id="edit-city-max-signup-input"
        />
      </Col>
      <Col xs={2} className={classes.button}>
        <SubmitButton
          value={
            programType === CITY_PROGRAMS.PROMO
              ? 'Submit Promo Campaign'
              : 'Submit Referral Campaign'
          }
          disabled={isDisabled}
          cypress_id="edit-city-submit-promo-referral-campaign-button"
        />
      </Col>
    </Form>
  </div>
)

export default injectStyles(styles)(ProgramForm)
